const styles = (theme) => ({
  content: {
    padding: theme.spacing(3),
    height: '100%',
    overflow: 'auto'
  },
  newGridContent: {
    padding: '0 30px 20px 30px',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      padding: '0 20px 20px 20px'
    }
  },
  gridContainer: {
    height: 600,
    '& .css-lzxddp td': {
      overflowWrap: 'anywhere !important',
      wordWrap: 'break-word !important',
      whiteSpace: 'normal !important',
    }
  },
  tableCellStyles: {
    learningPlan: {
      padding: '20px 16px',
      minWidth: 250,
      overflowWrap: 'break-word'
    },
    status: {
      padding: '20px 16px',
      minWidth: 120,
      overflowWrap: 'break-word'
    },
    locations: {
      padding: '20px 16px',
      minWidth: 200,
      overflowWrap: 'break-word'
    },
    pillars: {
      padding: '20px 16px',
      minWidth: 120,
      overflowWrap: 'break-word'
    },
    enrolledLearners: {
      padding: '20px 16px',
      minWidth: 150,
      overflowWrap: 'break-word'
    },
    actions: {
      padding: '20px 16px',
      minWidth: 100,
      overflowWrap: 'break-word'
    }
  },
  learningPlanName: {
    fontWeight: 500
  },
  learningPlanKey: {
    color: theme.palette.greyScale.grey
  },
  statusChip: {
    color: 'white',
    fontWeight: 500,
    maxWidth: 'fit-content',
    fontSize: '0.75rem'
  },
  statusChipActive: {
    backgroundColor: theme.palette.custom.green
  },
  statusChipInactive: {
    backgroundColor: theme.palette.custom.grey
  }
});

export default styles;

